export default __webpack_public_path__ + "static/media/Union.32653c90.svg";